import React from "react";
import { Link } from "react-router-dom";
import { MEDIA_URL } from "../../../configs";
import TimeAgo from "react-timeago";

const TopDownloadList = ({ downloadData }) => (
  <div className="mb-4 px-4 py-3 bg-white shadow rounded-4">
    <div className="d-flex justify-content-between mb-4 border-bottom pb-3">
      <strong>Top download</strong>
      <span className="text-muted">
        <i className="bi bi-three-dots-vertical"></i>
      </span>
    </div>
    {downloadData && downloadData.length > 0 ? (
      <ul className="list-unstyled">
        {downloadData.map((resource, index) => (
          <li className="mb-2 d-flex justify-content-start align-items-center" key={index}>
            <div className="text-center">
              {resource?.thumbnail && (
                <Link to={`/resources/edit/${resource._id}`}>
                  <img
                    src={`${MEDIA_URL}${resource?.thumbnail?.path}`}
                    width={64}
                    className="mx-auto my-2 img-fluid px-8"
                    alt={`Thumbnail for ${resource.name || 'resource'}`}
                  />
                </Link>
              )}
            </div>
            <div className="col-md-10 ms-4">
              <p className="mb-1 small list-title">
                <Link to={`/resources/view/${resource._id}`} className="text-dark">
                  {resource.name}
                </Link>
              </p>
              <div className="mb-1">
                {resource.created_at && (
                 <div className="me-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-clock me-1"></i>
                    <span className="text-break">
                      <TimeAgo date={resource.created_at} />
                    </span>
                </div>
                )}
                {resource.creator && (
                  <span className="mx-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-person me-1"></i>
                    <span>{resource.creator.username}</span>
                  </span>
                )}
              </div>
              <p className="text-muted mb-0">
                <span className="me-2 badge rounded-pill text-success py-1 px-2 fw-normal">
                  <i className="bi bi-arrow-down-short me-1"></i>
                  {resource.totalDownload}
                </span>
                <span className="me-2 badge rounded-pill text-primary py-1 px-2 fw-normal">
                  <i className="bi bi-eye me-1"></i>
                  {resource.viewCount}
                </span>
                <span className="me-2 badge rounded-pill text-danger py-1 px-2 fw-normal">
                  <i className="bi bi-heart me-1"></i>
                  {resource.likeCount}
                </span>
                <span className="me-2 badge rounded-pill text-info py-1 px-2 fw-normal">
                  <i className="bi bi-share me-1"></i>
                  {resource.shareCount}
                </span>
              </p>
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-muted">No top downloads to show.</p>
    )}
  </div>
);

export default TopDownloadList;
